<div class="title" [innerHTML]="title | safeHtml">
</div>
<div class="message" [innerHTML]="message | safeHtml" *ngIf="message">
</div>
<div class="buttons">
    <button (click)="cancel()" class="cancel" *ngIf="!hideCancel">Cancel</button>
    <button (click)="confirm()" class="confirm">OK</button>
</div>
